import { render } from "./TableCompanyShareIncrease.vue?vue&type=template&id=3f69be2f"
import script from "./TableCompanyShareIncrease.vue?vue&type=script&lang=js"
export * from "./TableCompanyShareIncrease.vue?vue&type=script&lang=js"

import exportComponent from "/builds/nex/company-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__